import { post } from '@/utils/request';
import type { LoginResult, MeResult } from '@/types/api';

export const sendCode  = (mobile: string) => post<void>('/login/sendCode', { mobile });
export const codeLogin = (mobile: string, code: string) =>
  post<LoginResult>('/login/codeLogin', { mobile, code });
export const pasLogin  = (username: string, password: string) =>
  post<LoginResult>('/login/pasLogin', { username, password });

export const me            = () => post<MeResult>('/auth/me');
export const editPassword  = (oldPassword: string, password: string, confirmPassword: string) =>
  post<void>('/auth/editPas', { oldPassword, password, confirmPassword });
export const logout        = () => post<void>('/auth/logout');
